import React, { useEffect, useRef, useState } from "react";
import ModalContainer from "../../common/ModalContainer";
import CommonSearchableDropdownInput from "../../common/inputs/CommonSearchableDropdownInput";
import getAdminTeam from "../../../controllers/user/getAdminTeam";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import assignTeamToAgent from "../../../controllers/user/assignTeamToAgent";

export const CustomerAssignAccountManagerModal = ({
  setOpen,
  open,
  data,
  callback,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [manager, setManager] = useState(
    data?.detail?.accountManager?._id || ""
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [assigning, setAssigning] = useState(false);
  const cancelTeamToken = useRef(null);
  const name = [data?.firstName, data?.lastName]
    .filter((item) => Boolean(item))
    ?.join(" ");
  const items = [
    {
      label: "ID",
      value: data?._id,
    },
    {
      label: "Company Name",
      value: data?.detail?.agencyName,
    },
    {
      label: "Contact Person",
      value: name,
    },
  ];

  useEffect(() => {
    setManager(data?.detail?.accountManager?._id || "");
  }, [data]);

  const loadOptions = async () => {
    if (!open) return;
    // if (!search) return;
    let cancellationMessage = "Operation canceled due to new request.";

    if (cancelTeamToken.current) {
      cancelTeamToken.current.cancel(cancellationMessage);
    }
    const params = {
      limit: 20,
    };
    if (search) {
      params.searchBy = "firstName,lastName,email,phone";
      params.keyword = search;
    }

    cancelTeamToken.current = axios.CancelToken.source();
    await getAdminTeam({
      cancelToken: cancelTeamToken.current.token,
      setLoading,
      param: new URLSearchParams(params)?.toString(),
    }).then((res) => {
      if (res?.data?.data?.length)
        setOptions(
          res?.data?.data?.map((item) => {
            const name = [item?.firstName, item?.lastName]
              .filter((itm) => Boolean(itm))
              .join(" ");
            return { ...item, code: item?._id, label: name };
          })
        );
    });
  };

  useEffect(() => {
    loadOptions();
  }, [search, open]);

  // console.log({ data });

  const handleConfirm = async () => {
    if (!manager) {
      return enqueueSnackbar("Please select an account manager first", {
        variant: "warning",
      });
    }
    const payload = {
      adminTeamId: manager,
      agentAccountId: data?._id,
    };
    await assignTeamToAgent(payload, setAssigning).then((res) => {
      if (res?.return) {
        const accountManager = options?.find(
          (option) => option?.code === res?.data?.data?.accountManager
        );
        const updatedData = {
          ...data,
          detail: {
            ...data?.detail,
            accountManager: accountManager || res?.data?.data?.accountManager,
          },
        };
        enqueueSnackbar("Agent asigned successfully!", {
          variant: "success",
        });
        callback?.(updatedData);
        setOpen?.(false);
      } else {
        enqueueSnackbar(res?.data?.message, {
          variant: "error",
        });
      }
    });
  };

  return (
    <>
      <ModalContainer
        open={open}
        setOpen={setOpen}
        padding="px-4 py-6"
        title="Assign Account Manager"
        childClassname="max-w-[600px]"
      >
        <div className="w-full flex flex-col lg:px-4">
          <div className="flex flex-col w-full gap-2 mb-3">
            {items?.map((item, itemIndex) => (
              <div className="w-full flex" key={itemIndex}>
                <span className="w-44 text-[#6D7C94] text-xs lg:text-sm">
                  {item.label}
                </span>
                <span className="flex text-xs lg:text-sm">{item.value}</span>
              </div>
            ))}
          </div>
          <CommonSearchableDropdownInput
            label="Account manager"
            placeholder="Search for account manager"
            value={manager}
            onChange={(val) => setManager(val)}
            loading={loading}
            options={options}
            search={search}
            onSearchChange={setSearch}
            onOpen={setDropdownOpen}
          />
          {dropdownOpen ? <div className="h-44"></div> : <></>}
          <hr className="w-full my-4 border border-gray-300" />
          <div className="flex items-center gap-2">
            <button className="w-32 lg:w-44 rounded-md h-12 bg-white flex items-center justify-center font-bold text-sm">
              Close
            </button>
            <button
              className="flex-1 rounded-md h-12 bg-primary1 text-white flex items-center justify-center font-bold text-sm"
              onClick={() => handleConfirm()}
            >
              {assigning ? <div className="buttonLoader"></div> : <>Confirm</>}
            </button>
          </div>
        </div>
      </ModalContainer>
    </>
  );
};
